"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.toPublicationListSlice = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var field_groups_1 = require("../field-groups");
var fields_1 = require("../fields");
var slice_1 = require("./slice");
var toPublicationListSlice = function (data, logger) {
    var _a;
    return utils_1.compact(__assign(__assign({}, slice_1.toAnchoredSlice(data, types_1.SliceType.PublicationList)), { title: logger.required(fields_1.toText((_a = data === null || data === void 0 ? void 0 : data.primary) === null || _a === void 0 ? void 0 : _a.section_title)), documents: data === null || data === void 0 ? void 0 : data.items.map(function (item) { return fields_1.toDocumentLink(item.document, logger); }).filter(Boolean), cta: field_groups_1.toCta(utils_1.unprefix('section', data === null || data === void 0 ? void 0 : data.primary), logger) }));
};
exports.toPublicationListSlice = toPublicationListSlice;
//# sourceMappingURL=publication-list-slice.js.map